<template>
  <!-- <v-app id="inspire" class="Kanit" style="height: calc(var(--vh, 1vh) * 100);"> -->
  <v-app id="inspire" class="Kanit">
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      disable-route-watcher 
      disable-resize-watcher
      class="nonPrint"
    >
      <LeftSide v-if="check_auth == true" @closedrawer="closedrawer" />
    </v-navigation-drawer>

    <v-toolbar dark fixed  class="toobar-color nonPrint">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" ><v-icon>menu</v-icon></v-app-bar-nav-icon>
      <v-toolbar-title>AED RED CROSS THAILAND</v-toolbar-title>
      <v-spacer></v-spacer> 
      <img :src="BASE_URL + 'static/icon/user.svg'" width="40px">
      <h4 class="hidden-sm-and-down">{{nameSuperadmin}}</h4>
      <!-- <v-menu offset-y >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on"  icon>
            <v-icon>fas fa-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile v-for="(item, i) in items" :key="i" >
            <v-list-tile-title @click="logout()" style="cursor: pointer;" class="pl-1 pr-1">{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->

      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
            >
              <v-icon>fas fa-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="Kanit" >
            <v-list-item-title @click="getProfileModal()" style="cursor: pointer;" class="pl-1 pr-1" >ข้อมูลโปรไฟล์</v-list-item-title>
            </v-list-item>
            <v-list-item class="Kanit" >
              <v-list-item-title @click="logout()" style="cursor: pointer;" class="pl-1 pr-1" >ออกจากระบบ</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-content class="screenShowDetail">
      <v-layout justify-center align-center>
        <v-flex text-xs-center style="padding-left: 20px;    padding-right: 20px;">
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-content>

    <EditProfile v-if="check_auth == true" :dialogedit_profile="dialogedit_profile" :dataProfile="dataProfile" @closeedit_profile="closeedit_profile" @updateProfile="updateProfile"></EditProfile>
  </v-app>
</template>

<script>
import LeftSide from '@/components/Layout/leftside'
import EditProfile from '@/components/edit/edit_profile_modal'
let vh = window.innerHeight * 0.01;
export default {
  data () {
    return {
      msg: 'layout',
      drawer: null,
      items: [
        { title: 'ออกจากระบบ' }
      ],
      BASE_URL: process.env.BASE_URL,
      nameSuperadmin: 'Superadmin',
      dataProfile: {},
      dialogedit_profile: false,
      check_auth: false,
    }
  },
  components: {
    LeftSide,
    EditProfile
  },
  created () {
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    this.$store.dispatch('CheckAuth')
    var decode = this.$store.state.key
    this.check_auth = this.$store.state.key ? true : false
    if (decode == undefined || decode.length <= 7) {
      localStorage.clear()
      this.$store.dispatch('ClearData')
      this.$router.push('/login')
    } else {
      if (this.$store.state.key_object.typeServer !== process.env.NODE_ENV) {
        this.$router.push('/login')
        localStorage.clear()
        this.$store.dispatch('ClearData')
      } else if (this.$store.state.key_object.role !== 'superadmin') {
        this.$swal('ขออภัย', 'คุณไม่มีสิทธิ์ในการลงชื่อเข้าใช้เว็บไซต์', 'error')
        localStorage.clear()
        this.$router.push('/login')
        this.$store.dispatch('ClearData')
      } 
      this.getDataUser()
    }
  },
  methods: {
    closedrawer (value) {
      this.drawer = value
    },
    updateProfile(value) {
      // console.log('test ' + value)
      this.dataProfile['first_name'] = value.first_name
      this.dataProfile['last_name'] = value.last_name
      if (value.first_name !== null && value.last_name != null) {
        this.nameSuperadmin = value.first_name + ' ' + value.last_name
      } else if (value.first_name !== null) {
        this.nameSuperadmin = value.first_name
      } else {
        this.nameSuperadmin = 'Superadmin'
      }
    },
    getDataUser () {
      this.nameSuperadmin = 'Superadmin'
      this.$api.getDataUser().then((response) => {
        if (response.data.message === 'success') {
          this.dataProfile = response.data.data
          if (response.data.data.first_name !== null && response.data.data.last_name != null) {
            this.nameSuperadmin = response.data.data.first_name + ' ' + response.data.data.last_name
          } else if (response.data.data.first_name !== null) {
            this.nameSuperadmin = response.data.data.first_name
          }
        } else {
          
        }
      })
    },
    closeedit_profile (value) {
      this.dialogedit_profile = value
    },
    getProfileModal () {
      this.dialogedit_profile = true
    },
    gotopath (path) {
      this.$router.push(path)
    },
    logout () {
      localStorage.clear()
      this.$store.dispatch('ClearData')
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar {
  margin-top: 5px;
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  margin-top: 5px;
  background: #d8d8d8;
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #aaaaaa;
  border-radius: 6px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(134, 133, 133);
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.swal-title {
  font-family: 'Kanit', sans-serif !important;
  }
>>>.swal2-show {
  font-family: 'Kanit', sans-serif !important;
}
>>>.swal2-popup {
  font-family: 'Kanit', sans-serif !important;
}
.toobar-color {
  background-color: #A80D00 !important;
  color: white;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
@media screen {
  .screenShowDetail {
    height: calc(100vh - 56px);
    overflow: auto;
  }
}
@media print {
  .screenShowDetail {
    height: auto;
    overflow: hidden;
  }
  .nonPrint {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/layout.vue